import { PresenceContext, useReducedMotion } from "motion/react";
import { useContext, useMemo } from "react";

import {
  getAnimatedPageTransition,
  getAnimatedPageVariants,
  getIsolatedPagePresenceContext,
} from "./animated-page.utils";

export const useAnimatedPage = ({
  durationSeconds,
  exitDurationSeconds,
}: {
  durationSeconds: number;
  exitDurationSeconds?: number;
}) => {
  const shouldReduceMotion = useReducedMotion() ?? false;
  const routePresenceContext = useContext(PresenceContext);
  const contentPresenceContext = useMemo(
    () => getIsolatedPagePresenceContext(routePresenceContext),
    [routePresenceContext],
  );

  return {
    variants: getAnimatedPageVariants({
      shouldReduceMotion,
      exitDurationSeconds,
    }),
    transition: getAnimatedPageTransition({
      durationSeconds,
      shouldReduceMotion,
    }),
    contentPresenceContext,
  };
};
